<template>
  <div class="access-denied-container">
    <div class="access-denied-box">
      <h1>🚫 Access Denied</h1>
      <p class="reason">You do not have permission to access this page.</p>
      <p class="details" v-if="!errorMessage">
        Reason: Your account does not have the required role or privileges to view this content.
      </p>
      <p class="details" v-else>Reason: {{ errorMessage }}</p>
      <router-link to="/" class="home-button">Go to Home</router-link>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'AccessDenied',
    props: {
      errorMessage: {
        type: String,
        default: '',
      },
    },
  };
</script>

<style scoped>
  .access-denied-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
    /* background-color: #f8f9fa; */
    padding: 20px;
    box-sizing: border-box;
  }

  .access-denied-box {
    text-align: center;
    background: white;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }

  .access-denied-box h1 {
    font-size: 2.5rem;
    color: #d9534f;
    margin-bottom: 1rem;
  }

  .reason {
    font-size: 1.2rem;
    color: #333;
    margin-bottom: 0.5rem;
  }

  .details {
    font-size: 1rem;
    color: #777;
    margin-bottom: 2rem;
  }

  .home-button {
    background-color: #007bff;
    color: white;
    padding: 12px 20px;
    text-decoration: none;
    border-radius: 6px;
    font-weight: bold;
  }

  .home-button:hover {
    background-color: #0056b3;
  }
</style>
